export const configuracionColumnasHistorialCrediticio = [
    {
        name: "mes",
        field: "mes",
        label: "Mes",
        align: "left",
    },
    {
        name: "deuda_total",
        field: "deuda_total",
        label: "Deuda total",
        align: "left",
    },
    {
        name: "deuda_vencida",
        field: "deuda_vencida",
        label: "Deuda vencida",
        align: "left",
    },
    {
        name: "institucion",
        field: "institucion",
        label: "Institución",
        align: "left",
    },
    {
        name: "observacion",
        field: "observacion",
        label: "Observación",
        align: "left",
    },
];
